import { Dashboard, TabsDisplay } from "api/model/dashboard/Dashboard";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import React, { useState } from "react";
import { T } from "services/lang/LanguageService";

interface ChangeTabsDisplayTypeDialogProps {
  isChangeTabsDisplayTypeDialogVisible: boolean;
  setChangeTabsDisplayTypeDialogVisibility: (isChangeTabsDisplayTypeDialogVisible: boolean) => void;
  dashboard: Dashboard;
  setDashboard: (dashboard: Dashboard) => void;
}

const tabLabelHandler = (value: string) => {
  return value === TabsDisplay.ROWS ? T("tabs-display.rows") : T(`tabs-display.dropdown`);
};

const typesOptions = Object.values(TabsDisplay).map(value => ({
  label: tabLabelHandler(value),
  value,
}));

const ChangeTabsDisplayTypeDialog = (props: ChangeTabsDisplayTypeDialogProps) => {
  const [selectedTabDisplayType, setSelectedTabDisplayType] = useState<TabsDisplay>(
    props.dashboard.tabsDisplay ?? TabsDisplay.ROWS
  );

  const handleSave = () => {
    const updatedDashboard = { ...props.dashboard, tabsDisplay: selectedTabDisplayType };
    props.setDashboard(updatedDashboard);
    props.setChangeTabsDisplayTypeDialogVisibility(false);
  };

  const footerTemplate = () => (
    <div>
      <Button
        label={T("word.cancel")}
        icon="pi pi-times"
        onClick={() => props.setChangeTabsDisplayTypeDialogVisibility(false)}
        className="p-button-sm p-button-danger"
      />
      <Button
        label={T("action.save")}
        icon="pi pi-check"
        onClick={handleSave}
        className="p-button-sm p-button-success"
      />
    </div>
  );

  return (
    <Dialog
      visible={props.isChangeTabsDisplayTypeDialogVisible}
      onHide={() => props.setChangeTabsDisplayTypeDialogVisibility(false)}
      header={T("action.change-tabs-display-type")}
      footer={footerTemplate}
      className="w-30rem"
    >
      <Dropdown
        className="w-full"
        value={selectedTabDisplayType}
        options={typesOptions}
        placeholder={T("action.change-tabs-display-type")}
        onChange={e => setSelectedTabDisplayType(e.value)}
      />
    </Dialog>
  );
};

export default ChangeTabsDisplayTypeDialog;
